<template>
  <div class="login">
    <div class="form-wrapper">
      <v-form class="form-login" ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="id" :rules="IdRules" label="Id" required ></v-text-field>
        <v-text-field type="password" v-model="password" :rules="passwordRules" label="Password" required></v-text-field>
        <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">Validate</v-btn>
        <v-btn color="error" class="mr-4" @click="reset">Reset Form</v-btn>
        <span style="color:white">{{this.errorMessage}}</span>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from "axios"
export default {
  name: 'Login',

  data () {
    return {
      valid: true,
      errorMessage: "",
      id: '',
      IdRules: [
        v => !!v || 'Id is required',
      ],
      password: '',
      passwordRules: [
        v => !!v || 'password is required',
      ]
    }
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.errorMessage = "";

        let login = () => {
          axios({
            method: "POST",
            url: "http://localhost:5000/api/login",
            data: {
              user: this.id,
              password: this.password
            }
          })
          .then((response) => {
            if(response.data.user) {
              return this.$router.push({name: 'Dashboard'} )
            } 
            if (response.data.error) {
              return this.errorMessage = response.data.error
            }
          })
          .catch((err) => {
            return this.errorMessage = err
          })
        }
        login()
      }
    },
    reset () {
      this.$refs.form.reset()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  background-color: grey;
  height: 100%;
  display: flex;
  align-items: center;
}
.form-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>